import { useSession } from "@whitecobalt/tungsten/esm/components/Session"

export const useOrganisation = (orgIndex: number = 0) => {
    const [{user}] = useSession()
    
    return user?.organisations[orgIndex]
}